import { render } from "./EstateCard.vue?vue&type=template&id=1190be63&scoped=true"
import script from "./EstateCard.vue?vue&type=script&lang=js"
export * from "./EstateCard.vue?vue&type=script&lang=js"

import "./EstateCard.vue?vue&type=style&index=0&id=1190be63&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1190be63"]])

export default __exports__